import { render, staticRenderFns } from "./WishlistIcon.vue?vue&type=template&id=a23dad7a&scoped=true&"
import script from "./WishlistIcon.vue?vue&type=script&lang=js&"
export * from "./WishlistIcon.vue?vue&type=script&lang=js&"
import style0 from "./WishlistIcon.vue?vue&type=style&index=0&id=a23dad7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23dad7a",
  null
  
)

export default component.exports